import { Term } from "@/core/store/terms/types";

export const organizationMappers = {
  mapLegalFormIdToName: (legalFormId: string): string => {
    if (legalFormId === "0") return "Private";
    if (legalFormId === "1") return "Public";
    return "Private";
  },

  mapOrganizationTypeToId: (typeName: string): string => {
    const typeMap: Record<string, string> = {
      Private: "0",
      Public: "1",
    };
    return typeMap[typeName] || "747";
  },

  mapCountryNameToId: (countryName: string, countriesData: Term[]): string => {
    const country = countriesData.find(
      (term: Term) => term.name === countryName,
    );
    //console.log(country?.tid, "tid country");
    return country?.tid || "0";
  },
  mapCountryIdToName: (countryId: string, countriesData: Term[]): string => {
    const country = countriesData.find((term: Term) => term.tid === countryId);
    //console.log(country?.tid, "tid country");
    return country?.name || "0";
  },

  mapOrganizationSizeToId: (sizeName: string, sizesData: Term[]): string => {
    const size = sizesData.find((term: Term) => term.name === sizeName);
    return size?.tid || "0";
  },

  mapSectorNamesToIds: (
    sectorNames: string[],
    sectorsData: Term[],
  ): string[] => {
    return sectorNames
      .map((sectorName) => {
        const sector = sectorsData.find(
          (term: Term) => term.name === sectorName,
        );
        return sector?.tid || "0";
      })
      .filter((id) => id !== "0");
  },

  mapSectorIdsToNames: (sectorIds: string[], sectorsData: Term[]): string[] => {
    if (!sectorIds) {
      return [];
    }
    return sectorIds
      .map((sectorId) => {
        const sector = sectorsData.find((term: Term) => term.tid === sectorId);
        return sector?.name || "";
      })
      .filter((name) => name !== "");
  },

  mapFundingTypeNamesToIds: (
    fundingTypeNames: string[],
    fundingTypesData: Term[],
  ): string[] => {
    return fundingTypeNames
      .map((fundingTypeName) => {
        const fundingType = fundingTypesData.find(
          (term: Term) => term.name === fundingTypeName,
        );
        return fundingType?.tid || "0";
      })
      .filter((id) => id !== "0");
  },
};
